import { useEffect, useState } from "react";
import { mealLogsApi, type MealLog } from "../api/client";
import { dateTimeLocalToIso, formatTime, toDateTimeLocalValue } from "../lib/date";
import { MealLogMedia } from "./MealLogMedia";

interface Props {
  log: MealLog;
  onChanged: () => Promise<void> | void;
  onDelete?: (id: string) => Promise<void> | void;
}

export function MealLogEntry({ log, onChanged, onDelete }: Props) {
  const [editingTime, setEditingTime] = useState(false);
  const [eatenAtValue, setEatenAtValue] = useState(toDateTimeLocalValue(log.eaten_at));
  const [savingTime, setSavingTime] = useState(false);

  useEffect(() => {
    setEatenAtValue(toDateTimeLocalValue(log.eaten_at));
  }, [log.eaten_at]);

  const onSaveTime = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!eatenAtValue) return;
    setSavingTime(true);
    try {
      await mealLogsApi.update(log.id, { eaten_at: dateTimeLocalToIso(eatenAtValue) });
      setEditingTime(false);
      await onChanged();
    } finally {
      setSavingTime(false);
    }
  };

  return (
    <div className="log-entry">
      <div className="list-item">
        <div className="list-item-main">
          <span className="list-item-title">{log.food_name}</span>
          <span className="list-item-sub">
            {formatTime(log.eaten_at)} · {log.kcal} kcal
          </span>
        </div>
        <div className="list-item-actions">
          <button
            type="button"
            className="btn-link"
            onClick={() => setEditingTime((current) => !current)}
          >
            {editingTime ? "閉じる" : "時刻変更"}
          </button>
          {onDelete && (
            <button type="button" className="btn-link" onClick={() => onDelete(log.id)}>
              削除
            </button>
          )}
        </div>
      </div>

      {editingTime && (
        <form className="log-time-form" onSubmit={onSaveTime}>
          <div className="field" style={{ marginBottom: 0 }}>
            <label htmlFor={`log-time-${log.id}`}>摂取日時</label>
            <input
              id={`log-time-${log.id}`}
              type="datetime-local"
              value={eatenAtValue}
              onChange={(e) => setEatenAtValue(e.target.value)}
            />
          </div>
          <div className="log-time-form-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => {
                setEatenAtValue(toDateTimeLocalValue(log.eaten_at));
                setEditingTime(false);
              }}
            >
              キャンセル
            </button>
            <button type="submit" className="btn-primary" disabled={savingTime || !eatenAtValue}>
              {savingTime ? "保存中…" : "時刻を保存"}
            </button>
          </div>
        </form>
      )}

      <MealLogMedia log={log} onChanged={onChanged} />
    </div>
  );
}